import Text from '@cartwhl/ui/base/Text';

export default function CartographerPage() {
  return (
    <main>
      <div className="container py-(--vertical-spacing)">
        <Text
          as="h1"
          variant="web/display/2xl"
          lg:variant="web/display/3xl"
          className="mt-16 lg:mt-[80px]"
        >
          Cartographer
        </Text>
      </div>
    </main>
  );
}
